import Form from "../CustomForm";
import useForm from "src/hooks/use-form";
import { useAlertContext } from "src/hooks/use-alert";

import ReassignTicketValidator from "src/validators/reassign-ticket-validator.ts";

import { ReassignTicket_,getAllTicketOperators } from "src/apis/tickets";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import { styled } from "@mui/material";

const useStyles = styled((theme) => {
  return {
    backButton: {
      marginRight: theme.spacing(1),
    },
    root: {
      display: "inline",
      flexDirection: "column",
      alignassets: "center",
      width: "100%",
    },
    field: {
      width: "30%",
      marginBottom: theme.spacing(2),
    },
  };
});


function filterTicketsWithStatus(tickets,statusId) {
  // if(tickets && tickets.length>0){
  return tickets.filter(ticket => ticket.actualStatus === statusId);}
// }


const validator = new ReassignTicketValidator();


const assetsList = [];
const sensorsList = [];

// To create a form, Create this object with eack key as the field of the form to create
var properties = {

 

  ticket: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    enum: assetsList,
    size:12
  },
  
  userIdReassigned: {
    value: "",
    type: "select",
    isTouched: false,
    hasError: false,
    size:12
  },

};

export default function ReassignTicket({ props }) {
  //props contain data regarding asset to from parent component
  const navigate = useNavigate();
  const alert = useAlertContext();
  const [assets, SetAssets] = useState([]);
  const [tickets,setTickets]=useState([]);
  const [items, SetItems] = useState([]);
  const [emails, SetEmails] = useState([]);
  const [visible, setVisible] = useState(false);
  const [id,setId]=useState(null);

  console.log(props.ticketData);
  useEffect(() => {
       var openTickets=filterTicketsWithStatus(props.ticketData,'Open');
       console.log("open tickets : ", openTickets);
      //  if(tickets && tickets.length>0){
        var tickets = openTickets.map((ticket) => {
          return { id: ticket.id, name: ticket.itemSnAssociated, asset:ticket.assetSnAssociated, prevAssigned:ticket.mntOperatorEmail, impactRegistered:ticket.actualImpactName , desc:ticket.description         };
        });
        setTickets(tickets);
      // } 
    
  }, [props]);

  console.log(tickets);



  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
    useForm(validator, properties);

  const conditionSelectChangeHandler = async (props, handler) => {
    handler(props);
    switch (true) {
      case props.target.value !== "":
        
      await getAllTicketOperators(props.target.value).then((res) => {
          if(res && res.length>0){
            setId(props.target.value)
            const operators = res.map((o) => {
              return { id: o.id, value: o.id, name: o.name + " " + o.surname };
            });
           
              SetEmails(operators);
            
           
          }
        });;
        break;
      default:
        setVisible(false);
        break;
    }
  };


  properties.ticket.enum = tickets; 
  properties.userIdReassigned.enum = emails;
  properties.ticket.conditionSelect = true;
  properties.ticket.conditionSelectChangeHandler = conditionSelectChangeHandler;

  // console.log(inputs)

  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    
      let data = {}; 
      for (const input in inputs) {
        if (input !== "asset") {
          if (input === "item" || input === "ticketImpact") {
            data[input] = {
              id: parseInt(inputs[input].value), 
            };
          } else {
            data[input] = inputs[input].value;
          }
        }
      }
      delete data["ticket"];
      var response;
      var message;
      console.log(data);

     
        response = await ReassignTicket_(data,id);
        message = "Ticket reassigned successfully!";
     

      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        alert.setTicketPageUpdate(true); //trigger tickets refetch in ticketing page after reassign
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
   
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
      <Form
        title={"Reassign Ticket"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack ?? null}
      />
      {visible }
    </>
  );
}
